// extracted by mini-css-extract-plugin
export var categoryIcon = "_bx-5";
export var connectorContainer = "_bx-1";
export var connectorLine = "_bx-0";
export var minHeight0 = "_bx-6";
export var relativeUnitValueSelector = "_bx-2";
export var trifoldSelectorBody = "_bx-4";
export var trifoldSelectorList = "_bx-3";